// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SessionTimeout-module__modalDialog--kW8po{width:26rem}.SessionTimeout-module__content--rg02O{font-size:.75rem;text-align:center}.SessionTimeout-module__header--FJ3uu{font-weight:500;font-size:1rem;color:var(--xm-main-text-color);padding-bottom:.4rem}.SessionTimeout-module__timer--VohUy{margin-top:.5rem;font-size:1rem;font-weight:500;color:var(--xm-main-text-color)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalDialog": "SessionTimeout-module__modalDialog--kW8po",
	"content": "SessionTimeout-module__content--rg02O",
	"header": "SessionTimeout-module__header--FJ3uu",
	"timer": "SessionTimeout-module__timer--VohUy"
};
export default ___CSS_LOADER_EXPORT___;
